import { Lock } from "lucide-react";

// Shown to plain admins on pages they can view but not change.
const SuperAdminOnlyNote = ({ className = "" }) => (
  <p
    className={`inline-flex items-center gap-1.5 rounded-lg bg-gray-100 px-3 py-1.5 text-xs text-gray-600 dark:bg-gray-800 dark:text-gray-300 ${className}`}
  >
    <Lock className="h-3.5 w-3.5" />
    Only a super admin can change this.
  </p>
);

export default SuperAdminOnlyNote;
